'use strict';

var defaultTheme$1 = require('../../../../_virtual/defaultTheme.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
require('./createMuiTheme.js');
var createMuiTheme = require('../../../../_virtual/createMuiTheme.js_commonjs-exports.js');

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(defaultTheme$1.__exports, "__esModule", {
  value: true
});
defaultTheme$1.__exports.default = void 0;

var _createMuiTheme = _interopRequireDefault(createMuiTheme.__exports);

var defaultTheme = (0, _createMuiTheme.default)();
var _default = defaultTheme;
defaultTheme$1.__exports.default = _default;
